import { useQuery } from '@tanstack/react-query';

import { SkyMapAxiosServiceFactory } from '../../../services/axios/skymap-axios-service-factory';
import { CloudFrontSigner } from '../../../utils/cloud-front-signer/cloud-front-signer';

export function useGeodataCloudFrontSigner(geodataId: string) {
  const { data } = useQuery({
    queryKey: ['getGeodataCloudFrontSigner', geodataId],
    queryFn: async () => {
      const result = await SkyMapAxiosServiceFactory.instance
        .createGeodataServiceV0()
        .getSignedRequestParameters({
          path: {
            geodataId,
          },
        });

      return new CloudFrontSigner(result.data);
    },
    networkMode: 'always',
    retry: false,
    refetchInterval: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  return data;
}
